<div
  *ngFor="let alert of alerts"
  class="alert {{cssClass(alert)}} alert-dismissable"
  [@fadeInOut]
>
  <img
    [src]="'assets/images/icons/' + iconAlert(alert) + '.svg'"
    alt="Alert icon"
    class="icon"
  />
  <span class="alert-message" [innerHTML]="alert.message"></span>
  <em
    class="close-button icon-close_small"
    (click)="$event.stopPropagation(); removeAlert(alert)"
  ></em>
</div>
